import script from "./ServiceSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceSelector.vue?vue&type=script&setup=true&lang=js"

import "./ServiceSelector.vue?vue&type=style&index=0&id=7ad26eb2&scoped=true&lang=css"

import exportComponent from "/var/www/dental/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ad26eb2"]])

export default __exports__